import React from 'react';
import {Helmet} from "react-helmet";

import picture from '../../assets/images/christhoval_bw.jpg';

import {Section} from '../containers';
import {Person, Picture, Socials, Story, UserInfo} from '../elements';

const About = ({api, ...props}) => {
	const {person, infos, socials, story, params} = api.getAbout();
	return (
		<Section id="about" className="padd-tb-60 white lighten-5 about-wrap">

			<Helmet>
				<meta property="og:image" content={picture}/>
				<meta property="og:url" content="/"/>
				<meta name="twitter:card" content="summary_large_image"/>

				<meta property="og:site_name" content="@christhoval"/>
				<meta name="twitter:image:alt" content="I Love Programming"/>


				<meta property="fb:app_id" content="christhoval06"/>
				<meta name="twitter:site" content="@christhoval"/>
			</Helmet>

			<div className="row">
				<div className="clearfix about-inner">
					<div className="col s12 m4">
						<Picture picture={picture}/>
					</div>
					<div className="col s12 m5">
						<div className="row">
							<Person {...props} {...person} />
						</div>
						<hr/>
						<div className="row">
							<UserInfo {...props} infos={infos} params={params}/>
						</div>
						<div className="row aligncenter text-center">
							<Socials {...socials}/>
						</div>
					</div>
					<div className="col s12 m3">
						<Story {...props} {...story} />
					</div>
				</div>
			</div>
		</Section>
	);
};

export default About;



// WEBPACK FOOTER //
// ./src/components/sections/About.js